export const MERKZETTEL_LISTE_LEER_EVENT = "sbe.merkzettel.listeLeer";
export const MERKZETTEL_LOAD_MORE_EVENT = "sbe.merkzettel.loadMore";
export const MERKZETTEL_ARTIKELAUSWAHL_ACTIVATE_EVENT = "sbe.merkzettel.artikelAuswahl.enabled";
export const MERKZETTEL_ARTIKELAUSWAHL_DEACTIVATE_EVENT = "sbe.merkzettel.artikelAuswahl.disabled";
export const MERKZETTEL_ARTIKELAUSWAHL_FINISH_EVENT = "sbe.merkzettel.artikelAuswahl.finish";

export const MERKZETTEL_ENTFERNEN_EVENT = "merkzettel.entfernt";
export const MERKZETTEL_UPDATE_EVENT = "merkzettel.update";

export const MERKZETTEL_KUNDENLISTE_ARTIKEL_ENTFERNT_EVENT = "sbe.merkzettel.kundenliste.artikelEntfernt";

export const MERKZETTEL_ARTIKELLISTE_UPDATE_EVENT = "merkzettel.artikellisteUpdate";